export const RATE = (periods, payment, present, future, type, guess) => {
  guess = guess === undefined ? 0.01 : guess;
  future = future === undefined ? 0 : future;
  type = type === undefined ? 0 : type;

  const epsMax = 1e-6;
  const iterMax = 100;
  let iter = 0;
  let close = false;
  let rate = guess;

  while (iter < iterMax && !close) {
    const t1 = Math.pow(rate + 1, periods);
    const t2 = Math.pow(rate + 1, periods - 1);
    const f1 =
      future + t1 * present + (payment * (t1 - 1) * (rate * type + 1)) / rate;
    const f2 =
      periods * t2 * present -
      (payment * (t1 - 1) * (rate * type + 1)) / Math.pow(rate, 2);
    const f3 =
      (periods * payment * t2 * (rate * type + 1)) / rate +
      (payment * (t1 - 1) * type) / rate;
    const newRate = rate - f1 / (f2 + f3);
    if (Math.abs(newRate - rate) < epsMax) {
      close = true;
    }
    iter++;
    rate = newRate;
  }
  if (!close) {
    return Number.NaN + rate;
  }
  return rate;
};

export const currencyFormatter = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(value);
};

export const currencyFormatterWithoutSymbol = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  })
    .format(value)
    .replace(/[$]/g, "");
};

export const percentFormatter = (value) => {
	return Number(value / 100).toLocaleString("en-US", {
		style: "percent",
		minimumFractionDigits: 2,
	});
};

export const getNumberFromCurrency = (currency) => {
  return Number(currency.replace(/[$,]/g, ""));
};
